import { Widgets } from "@mui/icons-material";

// DocumentSchema.js
export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [{ name: "Documents Required", component: "header" }],

        row2: [
          {
            name: "certificateofIncorporation",
            checkboxLabel: "Certificate of Association",
            sx: {
              width: "300px",
            },
            component: "checkboxbox",
          },
          {
            name: "certificateofIncorporation_upload",
            label: "Upload",
            component: "backlink",
            subComponent: "UploadRemoveDialog",
            action: "openSubDialog",
            visible: false,
          },
          {
            name: "certificateofIncorporation_download",
            label: "Download",
            component: "backlink",
            action: "downloadFile",
            visible: true,
          },
          {
            name: "certificateofIncorporation_remove",
            label: "Remove",
            component: "backlink",
            action: "removeFile",
            visible: false,
          },
        ],

        row3: [
          {
            name: "memorandumofAssociation",
            checkboxLabel: "Memorandum of Association",
            component: "checkboxbox",
            sx: {
              width: "300px",
            },
          
          },
          {
            name: "memorandumofAssociation_upload",
            label: "Upload",
            component: "backlink",
            subComponent: "UploadRemoveDialog",
            action: "openSubDialog",
            visible: false,
          },
          {
            name: "memorandumofAssociation_download",
            label: "Download",
            component: "backlink",
            action: "downloadFile",
            visible: false,
          },
          {
            name: "memorandumofAssociation_remove",
            label: "Remove",
            component: "backlink",
            action: "removeFile",
            visible: false,
          },
        ],

        row4: [
          {
            name: "articlesofAssociation",
            checkboxLabel: "Article of Association",
            component: "checkboxbox",
            sx: {
              width: "300px",
            },
          },
          {
            name: "articlesofAssociation_upload",
            label: "Upload",
            component: "backlink",
            subComponent: "UploadRemoveDialog",
            action: "openSubDialog",
            visible: false,
          },
          {
            name: "articlesofAssociation_download",
            label: "Download",
            component: "backlink",
            action: "downloadFile",
            visible: false,
          },
          {
            name: "articlesofAssociation_remove",
            label: "Remove",
            component: "backlink",
            action: "removeFile",
            visible: false,
          },
        ],

        row5: [
          {
            name: "powerofAttorney",
            checkboxLabel: "Power of Attorney",
            component: "checkboxbox",
            sx: {
              width: "300px",
            },
          },
          {
            name: "powerofAttorney_upload",
            label: "Upload",
            component: "backlink",
            subComponent: "UploadRemoveDialog",
            action: "openSubDialog",
            visible: false,
          },
          {
            name: "powerofAttorney_download",
            label: "Download",
            component: "backlink",
            action: "downloadFile",
            visible: false,
          },
          {
            name: "powerofAttorney_remove",
            label: "Remove",
            component: "backlink",
            action: "removeFile",
            visible: false,
          },
        ],

        row6: [
          {
            name: "copyofPANAllotment",
            checkboxLabel: "Copy of PAN Allotment",
            component: "checkboxbox",
            sx: {
              width: "300px",
            },
          },
          {
            name: "copyofPANAllotment_upload",
            label: "Upload",
            component: "backlink",
            subComponent: "UploadRemoveDialog",
            action: "openSubDialog",
            visible: false,
          },
          {
            name: "copyofPANAllotment_download",
            label: "Download",
            component: "backlink",
            action: "downloadFile",
            visible: false,
          },
          {
            name: "copyofPANAllotment_remove",
            label: "Remove",
            component: "backlink",
            action: "removeFile",
            visible: false,
          },
        ],

        row7: [
          {
            name: "copyofTelephoneBill",
            checkboxLabel: "Copy of Telephone Bill",
            component: "checkboxbox",
            sx: {
              width: "300px",
            },
          },
          {
            name: "copyofTelephoneBill_upload",
            label: "Upload",
            component: "backlink",
            subComponent: "UploadRemoveDialog",
            action: "openSubDialog",
            visible: false,
          },
          {
            name: "copyofTelephoneBill_download",
            label: "Download",
            component: "backlink",
            action: "downloadFile",
            visible: false,
          },
          {
            name: "copyofTelephoneBill_remove",
            label: "Remove",
            component: "backlink",
            action: "removeFile",
            visible: false,
          },
        ],

        row8: [
          {
            name: "gSTRegistrationCopy",
            checkboxLabel: "GST Registration Copy",
            component: "checkboxbox",
            sx: {
              width: "300px",
            },
          },
          {
            name: "gSTRegistrationCopy_upload",
            label: "Upload",
            component: "backlink",
            subComponent: "UploadRemoveDialog",
            action: "openSubDialog",
            visible: false,
          },
          {
            name: "gSTRegistrationCopy_download",
            label: "Download",
            component: "backlink",
            action: "downloadFile",
            visible: false,
          },
          {
            name: "gSTRegistrationCopy_remove",
            label: "Remove",
            component: "backlink",
            action: "removeFile",
            visible: false,
          },
        ],

        row9: [
          {
            name: "balanceSheet",
            checkboxLabel: "Balance Sheet",
            component: "checkboxbox",
            sx: {
              width: "300px",
            },
          },
          {
            name: "balanceSheet_upload",
            label: "Upload",
            component: "backlink",
            subComponent: "UploadRemoveDialog",
            action: "openSubDialog",
            visible: false,
          },
          {
            name: "balanceSheet_download",
            label: "Download",
            component: "backlink",
            action: "downloadFile",
            visible: false,
          },
          {
            name: "balanceSheet_remove",
            label: "Remove",
            component: "backlink",
            action: "removeFile",
            visible: false,
          },
        ],
      },
    },
  ],
};
